import PropTypes from 'prop-types';

import {
  ClassNameDefaultProps,
  ClassNamePropTypes,
} from '@/common/proptypes/Base/ClassName.protypes';

export const AutosuggestionsPanelDefaultProps = {
  ...ClassNameDefaultProps,
  panelMaxHeight: 500,
};

export const AutosuggestionsPanelPropTypes = {
  ...ClassNamePropTypes,
  panelMaxHeight: PropTypes.number,
};
